import React from "react";
import 'font-awesome/css/font-awesome.min.css';

function PlayButton(props) {
  return <button onClick={props.click}><i class="fa-solid fa-play"></i> Play Video</button>;
}

export default PlayButton;
